import { Badge } from '@/components/ui/badge';
import type { EditionStatus } from '@/types/releaseNotes';

/** Approved splits in two for the reviewer: scheduled until its publish time, live after it. */
export function EditionStatusBadge({ status, publishAt }: { status: EditionStatus; publishAt: string }) {
  if (status === 'draft') return <Badge variant="warning">Draft</Badge>;
  if (status === 'withdrawn') return <Badge variant="neutral">Withdrawn</Badge>;
  return new Date(publishAt) <= new Date() ? <Badge variant="success">Live</Badge> : <Badge variant="info">Scheduled</Badge>;
}
